import React, { useState, useEffect } from "react";
import Typography from "../Text/Typography";
import Icon from "../Icon/Icon";
import IconButton from "../Button/IconButton";
import "./NavigationTab.css";

interface NavigationTabProps {
  days: string[];
  selected: number;
  onSelect: (index: number) => void;
}

const NavigationTab: React.FC<NavigationTabProps> = ({ 
  days, 
  selected, 
  onSelect 
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const getDayAbbreviation = (dayName: string) => {
    return dayName.substring(0, 3);
  };

  const handlePreviousDay = () => {
    const newIndex = selected > 0 ? selected - 1 : days.length - 1;
    onSelect(newIndex);
  };

  const handleNextDay = () => {
    const newIndex = selected < days.length - 1 ? selected + 1 : 0;
    onSelect(newIndex);
  };

  // Mobile view - single day with navigation
  if (isMobile) {
    const dayName = getDayAbbreviation(days[selected]);

    return (
      <div className="navigation-tab-mobile">
        <div className="navigation-tab-mobile-date">
          <IconButton
            icon={<Icon name="chevron-left" size="large" />}
            onClick={handlePreviousDay}
            ariaLabel="Previous day"
            className="navigation-chevron"
          />
          <Typography variant="h3" className="navigation-tab-mobile-text">
            {dayName}
          </Typography>
          <IconButton
            icon={<Icon name="chevron-right" size="large" />}
            onClick={handleNextDay}
            ariaLabel="Next day"
            className="navigation-chevron"
          />
        </div>
      </div>
    );
  }

  // Desktop view - full week tabs
  return (
    <div className="navigation-tab-container">
      {days.map((day, idx) => (
        <button
          key={day}
          type="button"
          className={`navigation-tab${selected === idx ? " active" : ""}`}
          onClick={() => onSelect(idx)}
        >
          <Typography variant="body-bold" className="navigation-tab-label">
            {getDayAbbreviation(day)}
          </Typography>
        </button>
      ))}
    </div>
  );
};

export default NavigationTab; 